import React from 'react'
import PropTypes from 'prop-types'
import Sprite from './Sprite'
import cn from 'classnames'

const Logo = ({ inverted, className }) => {
  return (
    <Sprite
      id="logo"
      className={cn('c-logo', { 'c-logo--inverted': inverted }, className)}
    />
  )
}

Logo.propTypes = {
  inverted: PropTypes.bool,
  className: PropTypes.string,
}

Logo.defaultProps = {
  inverted: false,
}

export default Logo
